import { render } from "./App.vue?vue&type=template&id=194229c8"
const script = {}

import exportComponent from "/home/vsts/work/1/s/Archive/Site/archive/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__